module.exports = require("react-is");